import Vue from "vue";
import Router from "vue-router";
import AppHeaderWeb from "./layout/AppHeaderWeb";
import AppHeaderLogin from "./layout/AppHeaderLogin";
import AppHeaderMobile from "./layout/AppHeaderMobile";
import AppFooter from "./layout/AppFooter";
import Login from './views/Login/login'
import Deposit from './views/Deposit/deposit'
import Balance from './views/Balance/balance'
import Users from "./views/Users/users";
import WhatsApp from "./views/Whatsapp/whatsapp";
import UnApproved from "./views/UnApproved/unapproved";
import Approved from "./views/Approved/approved";
import Rejected from "./views/Rejected/rejected";
import Callback from './views/Callback';
import CustomerOveralTransactions from "./views/Reports/CustomerOveralTransactions/customeroveraltransactions"
import CustomerTransactions from "./views/Reports/CustomerTransactions/customertransactions"
import { userAuth } from './services/security'
import { Plugins } from '@capacitor/core';

const { App } = Plugins;

import config from "@/settings/config.js"


Vue.use(Router);

var header = AppHeaderWeb;
if (config.isMobile)
    header = AppHeaderMobile;

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        },
    },
    {
        path: "/login",
        name: "login",
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        }
    },
    {
        path: "/landing",
        name: "landing",
        components: {
            header: AppHeaderLogin,
            default: Login,
            footer: AppFooter
        },
    },
    {
        path: '/callback',
        name: 'callback',
        components: {
            header: header,
            default: Callback
        }
    },
    {
        path: "/approved",
        name: "approved",
        components: {
            header: header,
            default: Approved,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/rejected",
        name: "rejected",
        components: {
            header: header,
            default: Rejected,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/unapproved",
        name: "unapproved",
        components: {
            header: header,
            default: UnApproved,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/deposit",
        name: "deposit",
        components: {
            header: header,
            default: Deposit,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/balance",
        name: "balance",
        components: {
            header: header,
            default: Balance,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/whatsapp",
        name: "whatsapp",
        components: {
            header: header,
            default: WhatsApp,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/users",
        name: "users",
        components: {
            header: header,
            default: Users,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/customeroveraltransactions",
        name: "customeroveraltransactions",
        components: {
            header: header,
            default: CustomerOveralTransactions,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/customertransactions",
        name: "customertransactions",
        components: {
            header: header,
            default: CustomerTransactions,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    }
    ]
})

export default router;

App.addListener('appUrlOpen', function (data) {
    const slug = data.url.split('/').pop();
    router.push({
        path: '/' + slug,
    });
});

router.beforeEach(async (to, from, next) => {
    let app = userAuth.data().user || { isAuthenticated: false }
    const role = userAuth.getAuthorised();
    let hasRole = false;
    if (role) {
        if (Array.isArray(role))
            hasRole = role.includes("Operator");
        else
            hasRole = role === "Operator";
    }
    if (app.isAuthenticated && hasRole) {
        next()
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        await userAuth.SignOut();
        next();
    } else {
        //No auth required. We can navigate
        next()
    }
});